// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_2KrFL","batchTable":"List_batchTable_2OHss","detail":"List_detail_2ASnQ"};